import axios from 'axios'
import Utils from '../../utils/utils'
import CONST from '../../utils/const'
import vue from 'vue'
import config from '../../config'

export async function getToiletMgtData(condition = {}) {
  if(Utils.isEmptyObject(condition.id)) {
    console.error('iisi getToiletMgtData: scenicAreaId is null')
    return 
  }

  let scenicAreaIdQuery = "";
 
  //如果 id 長度大於1，則取得多個景點的廁所資訊
  if(condition.id.length > 1) {
    // console.log('getToiletMgtData', condition.id)
    //用每一個 id 組合`?scenicAreaIds=${condition.id}`的字串
    const query = condition.id.map((id) => `scenicAreaIds=${id}`).join('&');
     scenicAreaIdQuery = "?"+query;
    //  console.log('getToiletMgtData', scenicAreaIdQuery)
  }else{

     scenicAreaIdQuery = `?scenicAreaIds=${condition.id}`
  }
  let response = {}
  try {
      // response = await vue.http.get(`/api/toiletelk${scenicAreaIdQuery}`)
      response =  await axios.get(`${config.eastCoastDataApi()}BaseData/VideoCamera/PublicPlaceByVideoPurposeType${scenicAreaIdQuery}&videoPurposeTypes=toiletPersonFlow`)


  } catch (err) {
      console.error('iisi getToiletMgtData: ', err)
      return null
  }

  Utils.setApiResponsSuccess(response)
 
  return response
}

// export async function getToiletMgtData(condition = {}) {
//   if(Utils.isEmptyObject(condition.id)) {
//     console.error('iisi getToiletMgtData: scenicAreaId is null')
//     return 
//   }

//   let response = {}
//   // let scenicAreaIdQuery = `?value=${condition.id}`
//   let scenicAreaIdQuery = `?scenicAreaIds=${condition.id}`
//   try {
//       // response = await vue.http.get(`/api/toiletelk${scenicAreaIdQuery}`)
//       response =  await axios.get(`${config.eastCoastDataApi()}BaseData/VideoCamera/PublicPlaceByVideoPurposeType${scenicAreaIdQuery}&videoPurposeTypes=toiletPersonFlow`)


//   } catch (err) {
//       console.error('iisi getToiletMgtData: ', err)
//       return null
//   }

//   Utils.setApiResponsSuccess(response)
 
//   return response
// }


export async function getErrorToiletDevice() {
  //取得異常洗手乳 異味偵測 設備

  let response = {}
  try {
    response = await vue.http.get(`/api/ToiletError`)

  } catch (err) {
      console.error('iisi getErrorSnId: ', err)
      return null
  }

  Utils.setApiResponsSuccess(response)
  response.body = handleLntLng(response)
  return response
}

function handleLntLng(response) {
  if (Utils.isEmptyObject(response) || Utils.isEmptyObject(response.body)) {
    return response.body
  }

  const data = response.body

  for (let i = 0; i < data.length; i++) {
    data[i] = Utils.handleDeviceLntLng(data[i])

    if(data[i].operationType.toLowerCase() === CONST.EAST_COAST_DEVICE_TYPE.HAND_SANITIZER_DETECTOR.toLowerCase()) {
      data[i][CONST.TRAFFIC_CCTV_KEY.TYPE] = CONST.MAP_ICON_TYPE.HAND
    } else if(data[i].operationType.toLowerCase() === CONST.EAST_COAST_DEVICE_TYPE.PECULIAR_SMELL_DETETOR.toLowerCase()) {
      data[i][CONST.TRAFFIC_CCTV_KEY.TYPE] = CONST.MAP_ICON_TYPE.ODOR
    }
    
  }

  return data
}

export async function postTolietPeopleFlowInTimeIntervalPerHour(condition = {}) {
  let response = {}
  if (Utils.isEmptyObject(condition.sttime) || Utils.isEmptyObject(condition.endtime)) {
    console.error('iisi ostVehicleInTimeIntervalPerHour: time is null')
    return response
  }
  try {
      response = await axios.post('/api/ToiletELK/GetTolietPeopleFlowInTimeIntervalPerHour',condition);

      //console.log(response.data); // 如果API響應返回數據，它將在這裡打印出來
    } catch (error) {
      console.error('There was an error sending the POST request:', error);
    }
  Utils.setApiResponsSuccess(response)
  return response
}